import { MODAL_FETCHED } from "../types";
const initialState = {'activeClass' : false};

export default function meta(state = initialState, action = {}) {
  switch (action.type) {
    case MODAL_FETCHED:
          return { ...state, ...action.modal };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js